export default [
  // credits router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Credit",
      layout: "dashboard",
    },
    path: "/credits",
    name: "credits",
    component: () => import("@/layouts/index/CreditIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Crédits du clients",
          layout: "dashboard",
        },
        path: "index",
        name: "credits-index",
        component: () => import("@/views/credits/Listing.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Crédits du fournisseurs",
          layout: "dashboard",
        },
        path: "suppliers/index",
        name: "credits-suppliers-index",
        component: () => import("@/views/credits/suppliers/Listing.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Soldes créditeur du clients",
          layout: "dashboard",
        },
        path: "balances/index",
        name: "credits-balances",
        component: () => import("@/views/credits/Balance.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails soldes créditeur du clients",
          layout: "dashboard",
        },
        path: "balances/:customer_reference/all",
        name: "credits-balances-all",
        component: () => import("@/views/credits/BalanceDetails.vue"),
      },
    ],
  },
];
